<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Wallet" subTitle="Statement"></app-breadcrumb>
        
        <!-- statement -->
        <div class="row mt-3">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead class="bg-silver">
                            <tr v-if="countRecords">
                                <td colspan="5" class="bg-white p-1" style="border: 0px;">
                                    Showing 
                                    <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                                        <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                                    </select> 
                                    of {{countRecords.total}} records
                                </td>
                            </tr>
                            <tr>
                                <th>S/N</th>
                                <th>Description</th>
                                <th>Time</th>
                                <th class="text-right">Amount</th>
                            </tr>
                        </thead>
                        <tbody v-if="myWallet">
                            <tr v-for="(statement, i) in myWallet.statements.slice(0, recordsLimit)" :key="i">
                                <th>{{i+1}}.</th>
                                <td>
                                    <span v-if="statement.profit"> You sold {{statement.title}}</span>
                                    <span v-else> You bought {{statement.title}}</span>
                                </td>
                                <td>{{statement.soldTime | moment("MMM D 'YY hh:mm A")}}</td>
                                <td class="text-right">
                                    <span v-if="statement.profit" class="text-dark-green text-uppercase">
                                        {{statement.currency}} {{statement.price | money}}
                                    </span> 
                                    <span v-else class="text-danger text-uppercase">
                                        - {{statement.currency}} {{statement.price | money}}
                                    </span> 
                                </td>
                            </tr>
                            <tr>
                                <th>#</th>
                                <td colspan="2">
                                    Total Profit
                                </td>
                                <td class="text-right h4">
                                    <span class="text-uppercase">{{user.currency}}</span> {{myWallet.profit | money}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { paginateRecords } from '@/store/dry'

import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Statement",
    data() {
        return {
            recordsLimit: 0,
        }
    },
    methods: {
        ...mapActions(['fetchWallet']),
        modifyLimit(limit) {
            this.recordsLimit = limit
        }
    },
    computed: {
        ...mapGetters(['user', 'wallet']),
        myWallet() {
            if(this.wallet && this.wallet !== null){
                return this.wallet
            }
            return false
        },
        countRecords() {
            if(this.wallet && this.wallet.statements){
                let resultObj = paginateRecords(this.wallet.statements, 9)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        }
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchWallet().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutShop);
    }
}
</script>